import styled from 'styled-components';

export const SectionTitle = styled.h5`
    font-size: 14px;
    font-weight: 600;
    margin: 0;
    font-family: ${(props) => props.theme.app.font};
    display: flex;
    align-items: center;
    color: #263238;
`;
